<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['Grupo AD', 'Permissões', 'Acessos', 'Status', 'Ações']"
            :showNew="true"
            :showReload="true"
            :showSearch="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Edit="onEdit"
            v-on:Reload="onLoad"
            v-on:Search="onShowSearch">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <td class="text-center">
          <a
            v-on:click="onEdit(obj)"
            href="javascript:void(0)"
            v-bind:class="{ 'text-danger': !obj.active }"
          >
            <strong>{{ obj.adGroupName || '-' }}</strong>
            <br v-if="obj.adGroupDn">
            <small v-if="obj.adGroupDn" class="text-muted">{{ obj.adGroupDn }}</small>
          </a>
        </td>
        <td class="text-center">
          <b-badge
            v-for="perm in obj.permissoes"
            :key="perm"
            variant="primary"
            class="mr-1 mb-1"
          >
            {{ perm }}
          </b-badge>
          <span v-if="!obj.permissoes || obj.permissoes.length === 0" class="text-muted">
            Nenhuma
          </span>
        </td>
        <td class="text-center">
          <b-badge
            v-for="acesso in obj.acessos"
            :key="acesso"
            variant="info"
            class="mr-1 mb-1"
          >
            {{ acesso }}
          </b-badge>
          <span v-if="!obj.acessos || obj.acessos.length === 0" class="text-muted">
            Nenhum
          </span>
        </td>
        <td class="text-center">
          <b-badge
            :variant="getStatusVariant(obj)"
            class="mr-1"
          >
            {{ getStatusText(obj) }}
          </b-badge>
          <br v-if="obj.orphaned || obj.totalUsers !== undefined">
          <small class="text-muted" v-if="obj.orphaned">
            ⚠️ Grupo não encontrado no AD
          </small>
          <small class="text-muted" v-else-if="obj.totalUsers !== undefined">
            {{ obj.totalUsers }} usuário(s)
          </small>
        </td>
        <td class="text-center">
          <i
            v-on:click="onEdit(obj)"
            class="fa fa-edit text-primary icone-grid mr-2"
            style="cursor: pointer;"
            v-b-tooltip.hover
            title="Editar"
          ></i>
          <b-dropdown
            variant="link"
            size="sm"
            no-caret
          >
            <template slot="button-content">
              <i
                :class="obj.active ? 'fas fa-ban text-danger' : 'fa fa-check text-success'"
                class="icone-grid"
                style="cursor: pointer;"
                v-b-tooltip.hover
                :title="obj.active ? 'Inativar mapeamento' : 'Ativar mapeamento'"
              ></i>
            </template>
            <b-dropdown-header>
              <strong>{{ obj.active ? 'Deseja inativar este mapeamento?' : 'Deseja ativar este mapeamento?' }}</strong>
            </b-dropdown-header>
            <b-dropdown-item
              href="javascript:void(0);"
              @click="onToggleActive(obj)"
            >
              Sim
            </b-dropdown-item>
            <b-dropdown-item href="javascript:void(0);">
              Não
            </b-dropdown-item>
          </b-dropdown>
        </td>
      </tr>
    </Tables>
    <SidebarSearch @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import adSyncService from '@/shared/http/repositories/adsync/adsync'
import SidebarSearch from '../search/SidebarGroupMappings.vue'

export default {
  name: 'GroupMappingsList',
  mixins: [ActionsForm],
  components: {
    SidebarSearch
  },
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      adSyncService.getAllMappings()
        .then((response) => {
          if (response.data) {
            let items = Array.isArray(response.data) ? response.data : []

            // Aplicar filtros se existirem
            if (this.filters) {
              items = this.applyFilters(items)
            }

            this.onResultGridWithNoResponse(items, this.$refs.tableGrid)
            this.onStartTotalGrid(this.$refs.tableGrid, items.length)
          }
        })
        .catch(this.onException)
    },
    applyFilters (items) {
      if (!this.filters) return items

      let hasActiveFilters = false
      if (this.filters.adGroupName ||
          (this.filters.permissoes && this.filters.permissoes.length > 0) ||
          (this.filters.acessos && this.filters.acessos.length > 0)) {
        hasActiveFilters = true
      }

      if (!hasActiveFilters) return items

      return items.filter(item => {
        // Filtro por Grupo AD (correspondência exata)
        if (this.filters.adGroupName) {
          if (!item.adGroupName || item.adGroupName !== this.filters.adGroupName) {
            return false
          }
        }

        // Filtro por Permissões (deve conter todas as permissões selecionadas)
        if (this.filters.permissoes && this.filters.permissoes.length > 0) {
          const itemPermissoes = item.permissoes || []
          const hasAllPermissions = this.filters.permissoes.every(perm =>
            itemPermissoes.includes(perm)
          )
          if (!hasAllPermissions) {
            return false
          }
        }

        // Filtro por Acessos (deve conter todos os acessos selecionados)
        if (this.filters.acessos && this.filters.acessos.length > 0) {
          const itemAcessos = item.acessos || []
          const hasAllAccesses = this.filters.acessos.every(acesso =>
            itemAcessos.includes(acesso)
          )
          if (!hasAllAccesses) {
            return false
          }
        }

        return true
      })
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onToggleActive (obj) {
      loading.push()
      if (obj.active) {
        // Inativar
        adSyncService.deleteMapping(obj.id)
          .then((response) => {
            loading.pop()
            toast.success('Mapeamento inativado com sucesso!')
            this.onLoad()
          })
          .catch(this.onException)
      } else {
        // Ativar - precisamos enviar o objeto com active = true
        const updatedMapping = { ...obj, active: true }
        adSyncService.updateMapping(obj.id, updatedMapping)
          .then((response) => {
            loading.pop()
            toast.success('Mapeamento ativado com sucesso!')
            this.onLoad()
          })
          .catch(this.onException)
      }
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    getStatusVariant (obj) {
      if (obj.orphaned) return 'danger'
      if (!obj.active) return 'warning'
      return 'success'
    },
    getStatusText (obj) {
      if (obj.orphaned) return 'Órfão'
      if (!obj.active) return 'Inativo'
      return 'Ativo'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ADSync/components/list/GroupMappingsList.vue